import { useCallback, useState } from 'react';

export const useScrollState = (containerRef: React.RefObject<HTMLDivElement>) => {
  const [scrollState, setScrollState] = useState({
    currentScrollPosition: 0,
    canScrollNext: false,
    canScrollPrev: false,
  });

  const SCROLL_AMOUNT = 300; // 1回のスクロール量

  const updateScrollState = useCallback(() => {
    if (containerRef.current) {
      const scrollableWidth = containerRef.current.scrollWidth - containerRef.current.clientWidth;
      setScrollState((prevState) => ({
        ...prevState,
        canScrollNext: scrollableWidth > 0,
      }));
    }
  }, [containerRef]);

  const scroll = useCallback(
    (direction: 'prev' | 'next') => {
      if (containerRef.current) {
        const scrollAmount = direction === 'prev' ? -SCROLL_AMOUNT : SCROLL_AMOUNT;
        containerRef.current.scrollBy({
          left: scrollAmount,
          behavior: 'smooth',
        });
        const newScrollPosition = containerRef.current.scrollLeft + scrollAmount;
        const scrollableWidth = containerRef.current.scrollWidth - containerRef.current.clientWidth;
        setScrollState({
          currentScrollPosition: newScrollPosition,
          canScrollNext: newScrollPosition < scrollableWidth,
          canScrollPrev: newScrollPosition > 0,
        });
      }
    },
    [containerRef],
  );

  return { scrollState, scroll, updateScrollState };
};
